import React, { useState, useEffect } from 'react';
import axios from 'axios';
// import Layout from "../../../layout/default";


const CheckOut = () => {
  const [availableSpace, setAvailableSpace] = useState({
    left: true,
    middle: true,
    right: true
  });
  const [selectedSpace, setSelectedSpace] = useState('');

  // API call to check available space
  const checkAvailableSpace = async () => {
    try {
      const response = await axios.get('/usertree/check-available-space');
      if (response.data) {
        setAvailableSpace(response.data); // Assuming API returns an object like { left: true, middle: false, right: true }
      }
    } catch (error) {
      console.error('Error checking available space:', error);
    }
  };

  useEffect(() => {
    checkAvailableSpace(); // Check available space when the component mounts
  }, []);

  const handleSelection = (e) => {
    setSelectedSpace(e.target.value);
  };

  return (
    <div>
      <h2>Select Seat</h2>
      <div>
        <label>
          <input
            type="radio"
            value="left"
            checked={selectedSpace === 'left'}
            onChange={handleSelection}
            disabled={!availableSpace.left}
          />
          Left
        </label>
      </div>
      <div>
        <label>
          <input
            type="radio"
            value="middle"
            checked={selectedSpace === 'middle'}
            onChange={handleSelection}
            disabled={!availableSpace.middle}
          />
          Middle
        </label>
      </div>
      <div>
        <label>
          <input
            type="radio"
            value="right"
            checked={selectedSpace === 'right'}
            onChange={handleSelection}
            disabled={!availableSpace.right}
          />
          Right
        </label>
      </div>
      <button onClick={() => console.log('Buying the selected seat:', selectedSpace)}>
        Buy Seat
      </button>
    </div>
  );
};

export default CheckOut;
